<!-- Header Section Code Start -->
<section>
  <header *ngIf="!isGuestUser()" id="layout_wrapper">
    <nav class="header-top-section">
      <div class="container">
        <div class="top-white-section">
          <div>
            <a class="accessible skip-to-main" tabindex="0" aria-label="Skip to Content" 
            >Skip to Content</a
            >
          </div>
          <div class="header-padding">
            <!-- <a href="{{ demoLink }}" target="_blank" class="header-top-content"><img src="/assets/images/play_button.svg"
              alt="" aria-label="play"> <span>Click Here to Watch Demo</span></a> -->
            </div>
        </div>
      </div>
    </nav>
    <div class="header-section header-section-with-menu">
      <div class="container">

        <!-- Menu Section Code Start -->

        <div class="menu-toggle" role="navigation">
          <button class="hamburger hamburgerMenuButton" tabindex="0" [title]="menuOpen ? 'Menu Collapse' : 'Menu Expand'" id="hamburger-1" (click)="updateMenus()">
            <span class="line"></span>
            <span class="line"></span>
            <span class="line"></span>
          </button>
        </div>

        <div class="dashboard-menu" role="navigation" aria-label="Dashboard Menu">
          <div class="dashboard-menu-section">
            <ul class="dashboard-menu-list" *ngIf="role=='Student'" tabindex="0" aria-label="toggle-menu1">
              <li>
                <a href="javascript:void(0)" (click)="studentHome()" tabindex="0">
                  <img src="/assets/images/ABA_Home.svg" alt=""> Home
                </a>
              </li>
              <li *ngIf="current_category!=='Presentation'">
                <a  tabindex="0" [routerLink]="['/student/control/decision-status']" (click)="deactivateMenu()">
                  <img src="/assets/images/menu-simulation-dashboard.svg" alt=""> Action Plan Dashboard
                </a>
              </li>
              <li>
                <a tabindex="0" href="javascript:void(0)" (click)="navigateToBankReports()">
                  <img src="/assets/images/reports.svg" alt=""> Bank Reports
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" (click)="changePassword()">
                  <img src="/assets/images/changepassword.svg" alt=""> Change Password
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" tabindex="0" (click)="openHelpFromMenu('bank-modal')">
                  <img src="/assets/images/finance.svg" alt="Get Help"> Get Help
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" tabindex="0" (click)="openHelpFromMenu('overview-modal')">
                  <img src="/assets/images/help_info_icon.png" alt="Help Resources"> Help Resources
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" tabindex="0" (click)="openHelpFromMenu('contact-modal')">
                  <img src="/assets/images/email_letter.svg" alt="Contact Us"> Contact Us
                </a>
              </li>
              <li>
                <a tabindex="0" href="javascript:void(0)" (click)="authService.logout()">
                  <img src="/assets/images/logout.svg" alt=""> Logout
                </a>
              </li>
            </ul>
            <ul class="dashboard-menu-list" *ngIf="role!='Student'">
              <li>
                <a href="javascript:void(0)" (click)="simulationHome()">
                  <img src="/assets/images/ABA_Home.svg" alt="Simulation Dashboard"> Home
                </a>
              </li>
              <li *ngIf="isStatusPage==false">
                <a href="javascript:void(0)" (click)="simulationStatus()">
                  <img src="/assets/images/menu-simulation-dashboard.svg" alt="Simulation Dashboard"> Simulation
                  Dashboard
                </a>
              </li>
              <li *ngIf="role!='Instructor' && isStatusPage==false">
                <a href="javascript:void(0)" (click)="insControls()">
                  <img src="/assets/images/menu-instructor-controls.svg" alt="Instructor Controls"> Instructor Controls
                </a>
              </li>
              <li *ngIf="role!='Instructor' && isStatusPage==false">
                <a href="javascript:void(0)" (click)="simulationSetup()">
                  <img src="/assets/images/simulation-setup.svg" alt="Simulation Setup"> Simulation Setup
                </a>
              </li>

              <li *ngIf="isStatusPage==false">
                <a href="javascript:void(0);" (click)="analyticsPage()">
                  <img src="/assets/images/menu-analytics.svg" alt="Reports"> Reports
                </a>
              </li>
              <li *ngIf="role!='Instructor' && isStatusPage==false && decision_progress==false">
                <a href="javascript:void(0);" (click)="modifyCommunity()">
                  <img src="/assets/images/people.svg" alt="Create Modify Teams"> Create Modify Teams
                </a>
              </li>
              <li *ngIf="role!='Instructor' && isStatusPage==false">
                <a href="javascript:void(0);" (click)="addUserTeam()">
                  <img src="/assets/images/menu_user_plus.svg" alt="Add Users"> Add Users/Teams
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" (click)="changeNotification()">
                  <img src="/assets/images/email_notification.svg" alt="Notification"> Notification
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" (click)="changePassword()">
                  <img src="/assets/images/changepassword.svg" alt="Change Password"> Change Password
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" tabindex="0" (click)="openHelpFromMenu('bank-modal')">
                  <img src="/assets/images/finance.svg" alt="Get Help"> Get Help
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" tabindex="0" (click)="openHelpFromMenu('overview-modal')">
                  <img src="/assets/images/help_info_icon.png" alt="Help Resources"> Help Resources
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" tabindex="0" (click)="openHelpFromMenu('contact-modal')">
                  <img src="/assets/images/email_letter.svg" alt="Contact Us"> Contact Us
                </a>
              </li>
              <li>
                <a href="javascript:void(0)" (click)="authService.logout()">
                  <img src="/assets/images/logout.svg" alt="Logout"> Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- Menu Section Code Start -->

        <div>
          <div class="dashboard-logo" role="banner">
            <a [routerLink]="getHomeLink()" style="cursor: pointer;" >
              <img src="/assets/images/dashboard-logo.png" alt="American Bankers Association Logo" role="img"/>
            </a>
          </div>
        </div>
       
        <div class="dashboard-profile">
          <!-- <div class="profile-image">
            <img src="/assets/images/profile.png" alt="Profile" >
          </div>
        <div class="profile-info">
          <p class="profile-info-name">{{authService.getEmail()}}</p>
          <p class="profile-info-status">{{role}}</p>
        </div> -->
        </div>
      </div>
    </div>
  </header>
</section>
<!-- Header Section Code End -->


<!-- Dashboard Simulation Page Layout Section Code Start -->
<div class="dashboard-simulation-page" role="main" id="maincontent" tabindex="0">
  <div id="welcome-message-details" role="region">
    <div *ngIf="!isGuestUser()" class="dashboard-welcome-message">
      <div class="container">
       <span class="welcome-container"><span class="black-color">Welcome back, </span>
        <span class="user-name">
          <!-- {{authService.getFirstName()}} {{authService.getLastName()}} -->
          {{authService.getEmail()}}
        </span></span>

        <span class="black-color sim-name-container" *ngIf="role!='Student' && !hideOnTheseRoutes">Simulation Name :  <span class="user-name">&nbsp;{{selectedSession ? selectedSession.name : ''}}</span></span>
        <!-- student start-->
        <div class="dashboard-options" *ngIf="role=='Student'">
          <div tabindex="0" class="dashboard-team">
            <span class="black-color">Team:</span> <span *ngIf="running_quarter != 'Presession'"
class="user-name">{{stud_team}}</span>
          </div>

          <div class="dashboard-timer">
            <input type="hidden" id="count_down_date" [value]="time_remaining" />
            <input type="hidden" id="current_date" [value]="current_time" />

            <img src="assets/images/timer.svg" alt="Timer">
            
            <div tabindex="0" aria-labelledby="time_left_hidden1">
              <span id="time_left" aria-hidden="true"></span> <!-- Initially empty -->
              <div class="sr-only" id="time_left_hidden1" aria-live="assertive">
                <span id="time_left_hidden"></span>
              </div>
            </div>
            
          </div>

        </div>
        <!-- student end -->
      </div>
    </div>
  </div>


  <ng-content></ng-content>


  <!-- Right Side iocns Section Code Start -->
  <div id="user_layout_detail">
    <div *ngIf="!isGuestUser()" class="dashboard-support-section"
      [ngClass]="{'support-section-active': isHelpModalOpen}">
      <div class="db-support-section">
        <button class="db-support-icon" id="how-to-play-btn"
        (click)="toggleModal('bank-modal')"
          [ngClass]="{'support-icon-active': isBankModalOpen}"
          role="button" tabindex="0" aria-label="How to Play Section">
          <section aria-label="How to Play Section"><img class="db-support-icon1" src="assets/images/finance.svg" alt="How to Play"></section>
          <img class="db-support-icon2" src="assets/images/banking_finance.svg" alt="How to Play">
        </button>
        <button class="db-support-icon" id="support-btn"
        (click)="toggleModal('overview-modal')"
          [ngClass]="{'support-icon-active': isOverviewModalOpen}"
          role="button" tabindex="0" aria-label="Help Section">
          <section aria-label="Help Section"><img class="db-support-icon1" src="assets/images/help_info_icon.png" alt="Help"></section>
          <img class="db-support-icon2" src="assets/images/faq_help.svg" alt="Help">
        </button>
        <button class="db-support-icon" id="contact-btn" (click)="toggleModal('contact-modal')"
          [ngClass]="{'support-icon-active': isContactModalOpen}"
          role="button" tabindex="0" aria-label="Contact Us Section">
          <section aria-label="Contact Us Section"><img class="db-support-icon1" src="assets/images/email_letter.svg" alt="Contact Us"></section>
          <img class="db-support-icon2" src="assets/images/email_active.svg" alt="Contact Us">
        </button>
      </div>
    </div>
  </div>
  <!-- Right Side iocns Section Code End -->

    <!-- Get Help Bank code starts -->
    <div id="bank-modal" class="modal right-modal modal-style1">
      <div class="modal-content modal-content-60" >
        <div class="modal-main-content">
          <span class="close contact-modal-close"><img tabindex="0" src="assets/images/close_circle.svg" (click)="closeModal('bank-modal')"  (keydown.enter)="closeModal('bank-modal')"
              alt="Close"></span>
          <help-bank-content></help-bank-content>
              </div>
            </div>
          </div>
    <!-- Get Help Bank code ends -->

    <!-- Get Help overview code starts -->
    <div id="overview-modal" class="modal right-modal modal-style1" >
      <div class="modal-content modal-content-60" style="overflow: hidden;">
        <div class="modal-main-content" >
          <span class="close contact-modal-close"><img tabindex="0" src="assets/images/close_circle.svg" (click)="closeModal('overview-modal')" (keydown.enter)="closeModal('overview-modal')"
              alt="Close"></span>
          <help-overview-content></help-overview-content>
              </div>
            </div>
          </div>
    <!-- Get Help overview code ends -->

  <!-- Get Help code starts -->
  <div id="contact-modal" class="modal right-modal modal-style1">
    <div class="modal-content modal-content-30">
      <div class="modal-main-content">
        <span class="close contact-modal-close"><img tabindex="0" src="assets/images/close_circle.svg" (click)="closeModal('contact-modal')" (keydown.enter)="closeModal('contact-modal')"
            alt="Close"></span>
        <h1 class="modal-heading center">Contact Us</h1><br>
        <div class="contact-modal-content">
          <!-- <p><strong>Administrators:</strong><br> -->
            <!-- <strong>Phone:</strong> 1-800-BANKERS (<a href="tel:+8002265377">800-226-5377</a>) -->
          <!-- </p> -->
          <p><strong>Email:</strong> 
            <u>
            <a href="mailto:bxsupport@aba.com" aria-label="email, bx support @ a b a . com">
                bxsupport@aba.com
              </a>
            </u>
          </p>
          <p *ngIf="contact_session?.length" class="contact-section-heading" aria-label="Administrator Contact Information">Administrator Contact Information</p>
          <div *ngFor="let contact of contact_session" class="contact-person-section">
            <ng-container *ngIf="role !== 'Student' || !selectedSession || (+contact.work_session_id == +selectedSession?.id)">
              <p [attr.aria-label]="'Administrator name, ' + contact.full_name"><strong>{{contact.full_name}}</strong></p>
              <p><strong>Office Phone:</strong> <span [attr.aria-label]="'office phone number, ' + (contact.office_phone | mask: '000-000-0000')">{{contact.office_phone | mask: '000-000-0000'}}</span></p>
              <p><strong>Cell Phone:</strong> <span [attr.aria-label]="'cell phone number, ' + (contact.cell_phone | mask: '000-000-0000')">{{contact.cell_phone | mask: '000-000-0000'}}</span></p>
              <p><strong>Email:</strong> <a [href]="'mailto:' + contact.email" [attr.aria-label]="'email, ' + contact.email"><u>{{contact.email}}</u></a></p>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Get Help code ends -->

  <!-- Set Notification code starts -->
  <div id="notification-modal" class="modal">
    <div class="modal-dialog">
      <div class="modal-content modal-content-40">
        <div class="modal-main-content">
          <button class="close notification-modal-close" (click)="closeNotificationModal()"><img src="assets/images/close_circle.svg"
              (click)="closeNotificationModal()" alt="Close"></button>
          <h1 class="modal-heading center mb-30">Set Login Notification</h1>
          <div class="row">
            <form class="form-horizontal" #notificationForm="ngForm"
              (ngSubmit)="submitLoginNotification(notificationForm)">
              <div
                class="field-group vertical-field-group popup-field popup-checkbox-field notification-group notification-checkbox">
                <label for="text" class="simulation-text flex align-center">Notification Active Status</label>
                <input tabindex="0" aria-label="Notification Active Status" type="checkbox" name="is_notification_active"
                  [(ngModel)]="login_notification.is_notification_active"
                  (click)="setDateTimeNotification($event.target.value,'checkBoxMessage')"
                    (keydown.enter)="setDateTimeNotification($event.target.value,'checkBoxMessage')" />
              </div>

              <div class="field-group vertical-field-group popup-field popup-checkbox-field notification-group">
                <label for="text" class="simulation-text flex align-center">Start Date </label>
                <div class="deadline-input deadline-group notification-input">
                  <div class='input-group date datepicker' id="start_date_picker_notification">
                    <input title="text" aria-label="Start Date" type='text' class="form-control decision_datepicker" name="start_date_notification"
                      [(ngModel)]="login_notification.start_date_notification"
                      (click)="setDateTimeNotification($event.target.value,'startDate')"
                      [disabled]="!login_notification.is_notification_active" />
                    <span class="input-group-addon decision_datepicker">
                      <span class="glyphicon glyphicon-calendar">
                        <i class="fa-regular fa-calendar"></i>
                      </span>
                    </span>
                  </div>
                  <div class='input-group date timepicker' id="start_time_picker_notification">
                    <input title="text" aria-label="Start Time" type='text' class="form-control decision_datepicker width-70" name="start_time_notification"
                      [(ngModel)]="login_notification.start_time_notification"
                      (click)="setDateTimeNotification($event.target.value,'startTime')"
                      [disabled]="!login_notification.is_notification_active" />
                    <span class="input-group-addon decision_datepicker">
                      <span class="glyphicon glyphicon-time">
                        <i class="fa-regular fa-clock"></i>
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              <div class="field-group vertical-field-group popup-field popup-checkbox-field notification-group">
                <label for="text" class="simulation-text flex align-center">End Date </label>
                <div class="deadline-input deadline-group notification-input">
                  <div class='input-group date datepicker' id="end_date_picker_notification">
                    <input title="text" aria-label="End Date" type='text' class="form-control decision_datepicker" name="end_date_notification"
                      [(ngModel)]="login_notification.end_date_notification"
                      (click)="setDateTimeNotification($event.target.value,'endDate')"
                      [disabled]="!login_notification.is_notification_active" />
                    <span class="input-group-addon decision_datepicker">
                      <span class="glyphicon glyphicon-calendar">
                        <i class="fa-regular fa-calendar"></i>
                      </span>
                    </span>
                  </div>
                  <div class='input-group date timepicker' id="end_time_picker_notification">
                    <input title="text" aria-label="End Time" type='text' class="form-control decision_datepicker width-70" name="end_time_notification"
                      [(ngModel)]="login_notification.end_time_notification"
                      (click)="setDateTimeNotification($event.target.value,'endTime')"
                      [disabled]="!login_notification.is_notification_active" />
                    <span class="input-group-addon decision_datepicker">
                      <span class="glyphicon glyphicon-time">
                        <i class="fa-regular fa-clock"></i>
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              <div class="field-group vertical-field-group popup-field popup-checkbox-field notification-group">
                <label for="text" class="simulation-text flex align-center">Message </label>
                <textarea aria-label="Message textarea" class="notification-text" name="message_text"
                (click)="setDateTimeNotification($event.target.value,'messageContent')"
                [(ngModel)]="login_notification.message_text"
                  [disabled]="!login_notification.is_notification_active"></textarea>
              </div>

              <div class="form-group">
                <div class="button-container button-container-center">
                  <button type="button" class="modal-button forward-close" (click)="closeNotificationModal()">Cancel</button>
                  <button type="submit" class="modal-button yes-button"
                    [disabled]="this.error_message">Submit</button>
                </div>
              </div>
              <div class="sr-only" tabindex="0"></div>
              <div *ngIf="dateError" class="errormsg center" role="alert">
                {{error_message}}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Set Notification code ends -->
</div>
  <!-- Copy Right Section Code Start -->
  <footer id="footer_content" role="contentinfo" aria-label="Main Footer">
    <div *ngIf="!isGuestUser()" class="dasboard-copy-right">
      Copyright © {{ currentYearCopyRight }} American Bankers Association. All Rights Reserved.
    </div>
  </footer>
  <!-- Copy Right Section Code End -->
<!-- Dashboard Simulation Page Layout Section Code End -->
<div id="flash_message" tabindex="0" role="alert"></div>

<button id="decision_timeout" style="display: none" (click)="decision_timeout()"></button>